import collateralBuildPages from '@/routes/feature-locked-pages/feature-locked-collateral-build-pages';
import marketingPlanPages from '@/routes/feature-locked-pages/feature-locked-marketing-plan-pages';
import journeysPage from '@/routes/feature-locked-pages/feature-locked-journeys-pages';

export default [
    {
        pageType: 'Collateral Build',
        pages: collateralBuildPages 
    },
    {
        pageType: 'Marketing Plan',
        pages: marketingPlanPages 
    },
    {
        pageType: 'Journey',
        pages: journeysPage 
    },
];